import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Overview from './components/Overview';
import Users from './components/Users';
import Plans from './components/Plans';
import Settings from './components/Settings';
import Reports from './components/Reports';
import Pneumonia from './components/Pneumonia';
import BrainTumor from './components/BrainTumor';
import Profile from './components/Profile';
import History from './components/History';
import JoinRequest from './components/JoinRequest';
import JoinRequests from './components/JoinRequests';
import PaymentSuccess from './components/PaymentSuccess';
import Contact from './components/ContactUs'; // Renamed from ContactUs to Contact
import Messages from './components/Messages'; // Import the Messages component
import { setupInactivityDetection, setupTokenRefresh, logAuthEvent } from './firebase';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

function App() {
  useEffect(() => {
    // Setup security features
    const inactivityCleanup = setupInactivityDetection();
    const tokenRefreshCleanup = setupTokenRefresh();
    
    // Log application startup
    logAuthEvent('app_initialized', { timestamp: new Date().toISOString() });
    
    // Set up auth state listener for logging
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        logAuthEvent('user_session_started', { 
          userId: user.uid,
          email: user.email,
          emailVerified: user.emailVerified
        });
      }
    });
    
    // Cleanup function
    return () => {
      inactivityCleanup();
      tokenRefreshCleanup();
      unsubscribe();
    };
  }, []);
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/join-request" element={<JoinRequest />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<Overview />} />
          <Route path="overview" element={<Overview />} />
          <Route
            path="customers"
            element={
              <ProtectedRoute requiredRole="admin">
                <Users />
              </ProtectedRoute>
            }
          />
          <Route path="plans" element={<Plans />} />
          <Route
            path="settings"
            element={
              <ProtectedRoute requiredRole="admin">
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route path="reports" element={<Reports />} />
          <Route path="pneumonia" element={<Pneumonia />} />
          <Route path="brain-tumor" element={<BrainTumor />} />
          <Route path="profile" element={<Profile />} />
          <Route path="history" element={<History />} />
          <Route
            path="join-requests"
            element={
              <ProtectedRoute requiredRole="admin">
                <JoinRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="messages"
            element={
              <ProtectedRoute requiredRole="admin">
                <Messages />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;